module.exports = __webpack_public_path__ + "img/sc-2.5273e9b3.png";